import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { PaginateDocsAuditsRequest, PaginateDocsAuditsResponse } from "@maven-rest/docs/RefAudit.dto";
import { DocsAuditUrl } from "@maven-rest/docs/RefAudit.url";

// TODO 추후 mutation이 아닌 Query로 변경할 것
export function usePaginateDocsAuditMutation(req: {
  query: Record<string, string>;
  onSuccess: (data: PaginateDocsAuditsResponse, variables: PaginateDocsAuditsRequest, context: unknown) => void;
  onError: (error: RestError<PaginateDocsAuditsResponse>, variables: PaginateDocsAuditsRequest, context: unknown) => void;
}) {
  const { query, onSuccess, onError } = req;

  return useBaseMutation({
    fnOption: {
      url: DocsAuditUrl.paginateDocsAudits,
      query,
    },
    onSuccess,
    onError,
  });
}
